// extracted by mini-css-extract-plugin
module.exports = {"container":"ColorStopsHolder_container__3KXZR"};